// users type "mailto:" before actual email i.e. 'mailto:vik@v.com'
// to avoid invalid email error we remove everything before & including ':'

export function removeMailto(contact) {
  let { email } = contact

  if (!email) {
    return contact
  }

  const mailTo = 'mailto:'
  email = email.startsWith(mailTo) ? email.slice(mailTo.length) : email
  return {
    ...contact,
    email,
  }
}
